import breakpoints from '../../theme/breakpoints'
import theme from '../../theme/news12'

import css from 'styled-jsx/css'

export default css.global`
h1 {
    width: auto;
    margin: 40px 12px 12px 12px;
}

.edit-icon {
    margin-left: 5px;
    margin-bottom: 5px;
    cursor: pointer;
}

.choose-location-wrapper {
    width: 350px;
    padding: 27px;
    display: flex;
    background: ${theme.colors.drWhite};
    border: 1px solid #E4E8EF;
    border-radius: 5px;
    margin-top: 10px;
    flex-flow: column;
    align-items: center;
    margin-right: -65px;
    position: relative;
}

.choose-location-wrapper:before {
    content: "";
    width: 16px;
    height: 16px;
    position: absolute;
    top: -7px;
    right: 68px;
    background-image: url(/triangle-popover.svg);
    background-repeat: no-repeat;
}

.use-current-location {
    color: ${theme.colors.lightBlue};
    font-weight: 400;
    font-size: 14px;
    text-decoration-line: underline;
    background: none;
    border: none;
    cursor: pointer;
    margin-top: 28px;
}

.use-current-location.error {
    color: #FC4C02;
    font-size: 14px;
    display: flex;
    text-decoration: none;
}

.close-icon {
    position: absolute;
    top: 5px;
    right: 5px;
    background: none;
    border: none;
    cursor: pointer;
}

.autocomplete {
    width: 100%;
    display: flex;
    position: relative;
}

.autocomplete input {
    width: 100%;
    background: ${theme.colors.white};
    border: 1px solid #E4E8EF;
    font-weight: 400;
    font-size: 15px;
    padding: 8px 32px 8px 12px;
}

.autocomplete input::placeholder {
    color: ${theme.colors.lightGray5};
}

.autocomplete:before {
    content: "";
    width: 18px;
    height: 18px;
    top: 9px;
    right: 10px;
    position: absolute;
    background-image: url('/search-location.svg');
}

@media only screen and (max-width: ${breakpoints.sm}px) {
  h1 {
    font-size: 18px;
  }
  
  .choose-location-wrapper {
      width: 280px;
      padding: 27px;
    }
    
    .popover-container {
      width: 336px;
      position: absolute !important; 
      margin: 0 auto;
      top: 460px !important;
      left: 0 !important;
      right: 0;
      transform: unset !important;
    }
    
    .popover-container.no-layout {
      top: 340px !important;
    }
    
    .choose-location-wrapper:before {
      right: 40px;
    }
}
`
